<ng-container *ngIf="(isEditing$ | async) === true" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
  model: model$ | async,
  formGroup: formGroup$ | async
}">
</ng-container>

<ng-template #template let-ready="ready" let-model="model" let-formGroup="formGroup">
  <div flexLayout="column" flexLayoutAlign="start stretch">
    <formly-form [form]="formGroup" [fields]="fields" [options]="options" [model]="model">
    </formly-form>
    <div flexLayout="row" flexLayoutAlign="start center">
      <button mat-button
      color="warn"
      (click)="deleteTag()" type="button"
      *ngIf="restrictedAccess$ | async">
        <mat-icon mat-icon-button inline>delete</mat-icon>
        Delete Tag
      </button>
    </div>
  </div>
</ng-template>
